import { useState, useEffect, useImperativeHandle, forwardRef } from 'react';

export interface CountdownRef {
  getTimeLeft: () => number;
}

interface CountdownProps {
  initialSecond: number;
  onCountEnd: () => void;
  onCountStart: () => void;
}

const CountDown = forwardRef<CountdownRef, CountdownProps>(
  ({ initialSecond, onCountEnd, onCountStart }, ref) => {
    const [timeLeft, setTimeLeft] = useState<number>(initialSecond);

    useEffect(() => {
      onCountStart();
    }, []);

    useEffect(() => {
      if (timeLeft <= 0) {
        onCountEnd();
        return;
      }

      const intervalId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      // eslint-disable-next-line consistent-return
      return () => clearInterval(intervalId);
    }, [timeLeft]);

    useImperativeHandle(ref, () => ({
      getTimeLeft: () => timeLeft,
    }));

    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(
        remainingSeconds,
      ).padStart(2, '0')}`;
    };

    return <span>{formatTime(timeLeft)}</span>;
  },
);

export default CountDown;
